import { Constructor } from '@skylab-shared/types';
import { unique } from '@skylab-shared/utils';
import { AppInjector } from './app-injector';

type WrapperData = {
    static?: boolean
};

export function Wrapper(BaseClass: any, params: WrapperData = {}): any {
    return function (target: Constructor<unknown>) {
        const original = target;

        function build(constructor: Constructor<unknown>, args: unknown[]) {
            const construct: any = function () {
                return new constructor(...args);
            };
            construct.prototype = constructor.prototype;
            return new construct();
        }

        const f : any = function (...args: unknown[]) {
            const newTarget = build(original, args);
            copyBaseClassToTarget(newTarget);
            return newTarget;
        };

        function copyBaseClassToTarget(newClass: any) {
            const paramTypes = Reflect.getMetadata('design:paramtypes', target);

            if (!params.static) {
                if (paramTypes && paramTypes.length !== BaseClass.length) {
                    throw new Error(`Number of dependencies in wrapper is not equal to the number of dependencies in base class  -> ${BaseClass.name}`);
                }
                let dependencies = [];
                if (paramTypes && paramTypes.length > 0) {
                    dependencies = paramTypes.map(function(param: any) {
                        try {
                            return AppInjector.get(param);
                        } catch (err) {
                            throw new Error(`One of dependencies in ${BaseClass.name} not found.`);
                        }
                    });
                }
                newClass.baseInstance = new BaseClass(...dependencies);
            }

            // copy all properties from base class
            const baseRef = params.static ? BaseClass : newClass.baseInstance;

            const keys: string[] = [];
            const getAllKeys = function(instance: any) {
                const proto = Object.getPrototypeOf(instance);
                if (proto.isPrototypeOf(Object)) return unique(keys);
                const nonEnumProps = Object.getOwnPropertyNames(proto);
                const enumProps = Object.keys(instance);
                keys.push(...nonEnumProps, ...enumProps);
                return getAllKeys(proto);
            };

            for (const key of getAllKeys(baseRef)) {
                if (typeof baseRef[key] === 'function') {
                    Object.defineProperty(newClass, key, {
                        value: baseRef[key].bind(baseRef)
                    });
                } else {
                    Object.defineProperty(newClass, key, {
                        get: function() {
                            return baseRef[key];
                        }.bind(baseRef)
                    });
                }
            }
        }

        f.prototype = original.prototype;

        return f;
    };
  }
